var _rect, _rect2, _rect3, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g4, _g5, _g6, _g7, _g8, _g9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 720 907",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 907,
    fill: "#616161"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_8438)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1980,
    height: 1097,
    transform: "translate(-990 -94.5)",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -720,
    y: 1018.5,
    width: 1129,
    height: 1440,
    transform: "rotate(-90 -720 1018.5)",
    fill: "url(#paint0_linear_1_8438)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    filter: "url(#filter0_f_1_8438)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 694.5,
    cy: -144,
    r: 361.5,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.52,
    filter: "url(#filter1_f_1_8438)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -291.5,
    cy: 102.5,
    rx: 279.5,
    ry: 266,
    fill: "#5200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.5 102.5C-12.5 249.109 -137.389 368 -291.5 368C-445.611 368 -570.5 249.109 -570.5 102.5C-570.5 -44.1086 -445.611 -163 -291.5 -163C-137.389 -163 -12.5 -44.1086 -12.5 102.5Z",
    stroke: "#5200FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_f_1_8438)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 462.5,
    cy: 716.5,
    rx: 371.5,
    ry: 312,
    fill: "#5200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.5 716.5C833.5 888.458 667.483 1028 462.5 1028C257.517 1028 91.5 888.458 91.5 716.5C91.5 544.542 257.517 405 462.5 405C667.483 405 833.5 544.542 833.5 716.5Z",
    stroke: "#5200FF"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_8438)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.51,
    filter: "url(#filter3_f_1_8438)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M762 950H-30V-40H762V950Z",
    fill: "url(#paint1_radial_1_8438)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M762 950H-30V-40H762V950Z",
    fill: "url(#paint2_angular_1_8438)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M762 950H-30V-40H762V950Z",
    fill: "url(#paint3_radial_1_8438)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M762 950H-30V-40H762V950Z",
    fill: "url(#paint4_radial_1_8438)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M762 950H-30V-40H762V950Z",
    fill: "url(#paint5_radial_1_8438)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M762 950H-30V-40H762V950Z",
    fill: "url(#paint6_radial_1_8438)",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M762 950H-30V-40H762V950Z",
    fill: "url(#paint7_radial_1_8438)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M762 950H-30V-40H762V950Z",
    fill: "url(#paint8_radial_1_8438)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M762 950H-30V-40H762V950Z",
    fill: "url(#paint9_radial_1_8438)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M762 950H-30V-40H762V950Z",
    fill: "url(#paint10_radial_1_8438)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M762 950H-30V-40H762V950Z",
    fill: "url(#paint11_radial_1_8438)",
    style: {
      mixBlendMode: "hard-light"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-761.578 1198.15C-920.446 1127.73 -986.42 1042.28 -987.652 971.703C-988.884 901.131 -925.932 813.424 -769.618 737.505C-619.383 664.54 -405.873 615.375 -165.288 611.176C75.298 606.977 290.394 648.659 443.084 716.338C601.952 786.754 667.927 872.211 669.158 942.783C670.39 1013.36 607.438 1101.06 451.124 1176.98C300.889 1249.95 87.3792 1299.11 -153.206 1303.31C-393.792 1307.51 -608.887 1265.83 -761.578 1198.15ZM-1040.5 972.625C-1038.69 1076.17 -945.775 1174.32 -782.995 1246.47C-621.812 1317.91 -398.776 1360.46 -152.284 1356.16C94.2082 1351.85 315.623 1301.55 474.214 1224.52C634.378 1146.74 723.811 1045.41 722.003 941.861C720.196 838.315 627.281 740.169 464.501 668.018C303.318 596.576 80.2822 554.029 -166.21 558.331C-412.702 562.634 -634.117 612.939 -792.708 689.963C-952.872 767.751 -1042.3 869.08 -1040.5 972.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1173 362.698C-5.57411 205.466 -86.3993 149.017 -145.185 147.991C-203.97 146.965 -286.716 200.559 -361.852 355.263C-433.351 502.476 -482.102 713.127 -486.264 951.576C-490.426 1190.02 -449.056 1402.25 -382.739 1551.87C-313.048 1709.1 -232.223 1765.55 -173.437 1766.57C-114.652 1767.6 -31.9058 1714.01 43.2305 1559.3C114.729 1412.09 163.48 1201.44 167.642 962.989C171.804 724.541 130.434 512.317 64.1173 362.698ZM258.715 964.579C267.395 467.322 87.2745 60.948 -143.595 56.9181C-374.465 52.8883 -568.658 452.728 -577.337 949.986C-586.017 1447.24 -405.896 1853.62 -175.027 1857.65C55.8426 1861.68 250.036 1461.84 258.715 964.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.986 164.585C113.118 94.1685 47.1433 8.71137 45.9116 -61.8607C44.6797 -132.433 107.632 -220.14 263.946 -296.058C414.181 -369.024 627.691 -418.188 868.276 -422.388C1108.86 -426.587 1323.96 -384.904 1476.65 -317.226C1635.52 -246.81 1701.49 -161.352 1702.72 -90.7805C1703.95 -20.2084 1641 67.499 1484.69 143.417C1334.45 216.383 1120.94 265.547 880.357 269.747C639.772 273.946 424.676 232.263 271.986 164.585ZM-6.93336 -60.9383C-5.12595 42.6071 87.7886 140.754 250.569 212.904C411.752 284.347 634.788 326.894 881.28 322.592C1127.77 318.289 1349.19 267.984 1507.78 190.959C1667.94 113.172 1757.37 11.8424 1755.57 -91.7029C1753.76 -195.248 1660.85 -293.395 1498.06 -365.545C1336.88 -436.988 1113.85 -479.535 867.354 -475.233C620.862 -470.93 399.447 -420.625 240.855 -343.601C80.692 -265.813 -8.74068 -164.484 -6.93336 -60.9383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1097.68 -670.865C1027.99 -828.098 947.165 -884.546 888.379 -885.572C829.594 -886.599 746.848 -833.005 671.711 -678.301C600.213 -531.087 551.462 -320.437 547.3 -81.9883C543.138 156.46 584.508 368.684 650.825 518.303C720.516 675.535 801.341 731.984 860.127 733.01C918.912 734.036 1001.66 680.442 1076.79 525.738C1148.29 378.525 1197.04 167.874 1201.21 -70.5744C1205.37 -309.023 1164 -521.247 1097.68 -670.865ZM1292.28 -68.9847C1300.96 -566.242 1120.84 -972.616 889.969 -976.646C659.099 -980.676 464.906 -580.836 456.227 -83.578C447.547 413.679 627.667 820.053 858.537 824.083C1089.41 828.113 1283.6 428.273 1292.28 -68.9847Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#filter4_f_1_8438)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 618.5,
    cy: 90.5,
    r: 361.5,
    fill: "#5200FF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55,
    filter: "url(#filter5_f_1_8438)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 498.5,
    cy: 520.5,
    r: 361.5,
    fill: "#5200FF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#filter6_f_1_8438)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 268.5,
    cy: 870.5,
    r: 361.5,
    fill: "black"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#filter7_f_1_8438)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 727,
    cy: 125,
    rx: 540,
    ry: 237,
    transform: "rotate(-18.4094 727 125)",
    fill: "black"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#filter8_f_1_8438)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -105.789,
    cy: 556.594,
    rx: 540,
    ry: 237,
    transform: "rotate(-18.4094 -105.789 556.594)",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_8438",
    x: -167,
    y: -1005.5,
    width: 1723,
    height: 1723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_1_8438"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_8438",
    x: -1071,
    y: -663.5,
    width: 1559,
    height: 1532,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_1_8438"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1_8438",
    x: -409,
    y: -95.5,
    width: 1743,
    height: 1624,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_1_8438"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1_8438",
    x: -54,
    y: -64,
    width: 840,
    height: 1038,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_1_8438"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1_8438",
    x: -243,
    y: -771,
    width: 1723,
    height: 1723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_1_8438"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1_8438",
    x: -363,
    y: -341,
    width: 1723,
    height: 1723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_1_8438"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1_8438",
    x: -593,
    y: 9,
    width: 1723,
    height: 1723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_1_8438"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1_8438",
    x: -170.871,
    y: -537.237,
    width: 1795.74,
    height: 1324.47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 190,
    result: "effect1_foregroundBlur_1_8438"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1_8438",
    x: -1003.66,
    y: -105.643,
    width: 1795.74,
    height: 1324.47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 190,
    result: "effect1_foregroundBlur_1_8438"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_8438",
    x1: -155.5,
    y1: 717,
    x2: -155.5,
    y2: 2732.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12132F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12132F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12132F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_8438",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(268 504) rotate(2.41103) scale(570.505 1259.85)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_1_8438",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(570 92) rotate(12.4445) scale(247.999 528.305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.495182,
    stopColor: "#5200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5200FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1_8438",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.518 312.153) rotate(116.744) scale(743.367 632.634)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411761,
    stopColor: "#FF003D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719902,
    stopColor: "#5200FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1_8438",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6793 855.368) rotate(-10.8495) scale(963.544 570.767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.192069,
    stopColor: "#FF003D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545432,
    stopColor: "#5200FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1_8438",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(618 624) rotate(-19.957) scale(1500.08 656.488)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.386502,
    stopColor: "#FF003D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBFF00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1_8438",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(692.184 472.308) rotate(77.977) scale(374.415 1001.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507408,
    stopColor: "#5200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5200FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1_8438",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(285.191 720.89) rotate(-161.493) scale(401.804 218.249)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259592,
    stopColor: "#5200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1_8438",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(702.731 469.284) rotate(80.2593) scale(441.028 704.728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605789,
    stopColor: "#5200FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832381,
    stopColor: "#5200FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1_8438",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(247.882 562.118) rotate(3.51014) scale(467.633 206.469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414475,
    stopColor: "#5200FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5200FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1_8438",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1090 416) rotate(163.796) scale(974.72 165.808)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#FF003D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831859,
    stopColor: "#DBFF00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1_8438",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(822 390) rotate(65.6719) scale(572.87 2560.17)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#FF003D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483429,
    stopColor: "#DBFF00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_8438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 907,
    fill: "white",
    transform: "translate(-720)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_8438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 907,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/loginBackground.776aefaeddfabb408e8ff669d69475f5.svg";
export { ForwardRef as ReactComponent };